import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import PagoAnticipadoComponent from "../../../components/comisionesMembresia/pagoAnticipado/PagoAnticipado";
import {
  PagoAnticipadoStore,
  pagoAnticipadoStore
} from "./PagoAnticipado.store";
import {
  PagoAnticipadoDispatcher,
  pagoAnticipadoDispatcher
} from "./PagoAnticipado.dispatcher";
import Layout from "../../../components/layout";

interface Props extends PagoAnticipadoStore, PagoAnticipadoDispatcher {}
interface State {}

@Router()
@ReduxConnect(pagoAnticipadoStore, pagoAnticipadoDispatcher)
export default class PagoAnticipadoContainer extends Component<Props, State> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Pago Anticipado - Empleados Dados de Baja" />
          <PagoAnticipadoComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
